module.exports = __webpack_public_path__ + "static/media/206-gallery16.e5fe8e44.jpg";